<template>
  <div
    :class="[
      classNameBase.rootElement,
      `${classNameBase.rootElement}${classNameDirection[isYouSent]}`
    ]"
  >
    <div
      :class="[
        classNameBase.col,
        `${classNameBase.col}${classNameDirection[isYouSent]}`
      ]"
    >
      <div v-if="!isYouSent" class="p-the-j05-chat-screen-panel-message__icon">
        <IconUserImage :size="32">
          <img :src="partnerUserImage" alt />
        </IconUserImage>
      </div>

      <div
        :class="[
          classNameBase.message,
          `${classNameBase.message}${classNameDirection[isYouSent]}`
        ]"
      >
        <slot name="content" />
      </div>

      <div
        v-if="nextItemTime !== time"
        class="p-the-j05-chat-screen-panel-message__time"
      >
        <SmallText color="#333333" :size="timeTextFontSize">{{
          time
        }}</SmallText>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import SmallText from "@/common/components/atoms/SmallText.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import { Options, Vue } from 'vue-class-component';
import * as dayjs from "dayjs";
import "dayjs/locale/ja"; // import locale
import utc from "dayjs/plugin/utc";
import globals from "@/general/store/modules/globals";

dayjs.extend(utc);

@Options({
  props: {
    chatData: { type: Object, required: true },
    isSp: { type: Boolean, required: true },
    isYouSent: { type: Boolean, required: true },
    classNameDirection: { type: Object, required: true },
    partnerUserImage: { type: String, default: "" }
  },
  components: {
    SmallText,
    IconUserImage
  }
})
export default class J05ChatScreenPanelMessage extends Vue {
  chatData!: any;
  isSp!: boolean;
  isYouSent!: boolean;
  classNameDirection!: any;
  partnerUserImage!: string;

  classNameBase = {
    rootElement: "p-the-j05-chat-screen-panel-message",
    col: "p-the-j05-chat-screen-panel-message__col",
    message: "p-the-j05-chat-screen-panel-message__message"
  };

  get chatLog() {
    return this.chatData.chatLog;
  }

  get time() {
    const date = this.chatData.date;
    return dayjs
      .utc(date)
      .format("HH:mm");
  }

  get key() {
    return this.chatData.key;
  }

  get nextItemTime() {
    const key = this.chatData.key;
    const chatLog = this.chatData?.chatLog;
    if (!chatLog || !Array.isArray(chatLog)) return "";
    const lastKey = chatLog.length - 1;
    return key < lastKey ? chatLog[key + 1]?.time ?? "" : "";
  }

  get timeTextFontSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 11 : 14;
  }
}
</script>

<style lang="scss" scoped>
.p-the-j05-chat-screen-panel-message {
  &--r {
    display: flex;
    justify-content: flex-end;
    padding-right: rem(8);
  }
  &--l {
    padding-left: rem(8);
  }
  &__col {
    display: flex;
    @include pc {
      max-width: 80%;
    }

    &--r {
      justify-content: flex-start;
      flex-direction: row-reverse;
    }
  }

  &__icon + &__message--l {
    @include pc {
      margin-left: rem(20);
    }
    @include sp {
      margin-left: rem(12);
    }
  }

  &__message {
    &--l {
      @include pc {
        margin-left: rem(32 + 20);
      }
      @include sp {
        margin-left: rem(32 + 12);
      }
    }
  }

  &__time {
    @include sp {
      min-width: rem(50);
      text-align: center;
    }
    margin: auto 0 0 0;
    display: block;
  }

  &--r &__time {
    @include pc {
      margin-right: rem(8);
    }
    @include sp {
      margin-right: rem(4);
    }
  }

  &--l &__time {
    @include pc {
      margin-left: rem(8);
    }
    @include sp {
      margin-left: rem(4);
    }
  }
}

.p-the-j05-chat-screen-panel-message__message {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

</style>
